module.exports = __webpack_public_path__ + "static/media/appUpdate.462cbbd3.png";